/**
 * Supprime les balises HTML et décode les entités pour obtenir du texte brut.
 * Utile pour l'aperçu des descriptions dans les cartes de listing.
 * @param {string} html - La chaîne HTML à nettoyer
 * @param {number} maxLength - Longueur maximale du texte (défaut: 200)
 * @returns {string} Texte brut tronqué
 */
export function stripHtml(html, maxLength = 200) {
  if (!html) return '';

  // Remplacer les balises de bloc par des espaces pour éviter les mots collés
  let text = html
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/p>/gi, ' ')
    .replace(/<\/div>/gi, ' ')
    .replace(/<\/li>/gi, ' ')
    .replace(/<\/h[1-6]>/gi, ' ');

  // Supprimer toutes les balises HTML restantes
  text = text.replace(/<[^>]+>/g, '');

  // Décoder les entités HTML courantes
  text = text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&rsquo;/gi, "'")
    .replace(/&lsquo;/gi, "'")
    .replace(/&rdquo;/gi, '"')
    .replace(/&ldquo;/gi, '"');

  // Nettoyer les espaces multiples
  text = text.replace(/\s+/g, ' ').trim();

  // Tronquer si nécessaire
  if (text.length > maxLength) {
    text = text.substring(0, maxLength).trim() + '...';
  }

  return text;
}
